require('babel-polyfill')
const gc = require("../config/gc");

const bucket = gc.bucket(process.env.GCLOUD_PRIVATE_BUCKET);

const uploadFile = async (filePath, gCloudDestination) => {
    try {
        return new Promise((resolve, reject) => {
            bucket.upload(filePath, {
                destination: gCloudDestination,
            }, (err, file) => {
                if (err) {
                    reject(err)
                }
                resolve(`${process.env.GCLOUD_BASE_URL}/${bucket.name}/${gCloudDestination}`);
            });
        })
    } catch(err) {
        throw err;
    }
}

const uploadBuffertoGc = async (buffer, gCloudDestination) => {
    try {
        let blob = bucket.file(gCloudDestination);
        const blobStream = blob.createWriteStream({
            resumable: false
        });
        return new Promise((resolve, reject) => {
            blobStream.on('error', (err) => {
                reject(err);
            }).on('finish', () => {
                const publicUrl = `${process.env.GCLOUD_BASE_URL}/${bucket.name}/${blob.name}`;
                resolve(publicUrl);
            }).end(buffer);
        });

    } catch (err) {
        throw err;
    }
}

const streamToGc = async (stream, gCloudDestination) => {
    try {
        let blob = bucket.file(gCloudDestination);
        const blobStream = blob.createWriteStream({
            resumable: false
        });
        return new Promise((resolve, reject) => {
            stream.pipe(blobStream).on('finish', () => {
                const publicUrl = `${process.env.GCLOUD_BASE_URL}/${bucket.name}/${blob.name}`;
                resolve(publicUrl);
            }).on('error', (err) => {
                reject(err);
            });
        });
    } catch(err) {
        throw err;
    }
}

const generateV4ReadSignedUrl = async (fileName, expiresInMin) => {
    try {
        const blob = bucket.file(fileName);

        const [url] = await blob.getSignedUrl({
            version: 'v4',
            action: 'read',
            expires: Date.now() + expiresInMin * 60 * 1000
        });

        return url;
    } catch (err) {
        throw err;
    }
}

module.exports = {
    uploadFile,
    uploadBuffertoGc,
    streamToGc,
    generateV4ReadSignedUrl
}